import { styled } from 'parkdepot-shared/theme'

const LongDurationTempPlaceholder = styled('div', ({ $theme }) => ({
    height: '7.8rem',
    width: '100%',
    [$theme.mediaQuery.large]: {
        backgroundColor: 'white',
        minWidth: '42rem',
        height: '11.7rem'
    }
}))

export default LongDurationTempPlaceholder
